import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import MessageSuccess from '../../components/form/MessageSuccess';
import WebEventController from '../../controller/web-event.controller';
import {WebEventUtil} from '../../util/web-event-util';
import {I18n} from '../../util/i18n';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import GieCard from "../../components/GIECard/GieCard";
import MyCoordinateFormDetail from "../../components/form/MyCoordinateFormDetail";
import MyEquipmentFormDetail from './EquipmentFormDetail';
import HeaderForm from "../../components/form/HeaderForm";

export default class EquipmentForm extends React.Component<any, any> {
  webEventController: WebEventController = new WebEventController();

  constructor(props: any) {
    super(props);
    this.state = {
      dataSend: false,
      step: 0,
      dataFirstStep: null
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeForm = () => {
    this.setState({dataSend: true})
  }

  getDataFirstStep = (dataFirstStep) => {
    this.setState({dataFirstStep})
    this.next();
  }

  next = () => {
    this.setState({step: this.state.step + 1})
  }

  previous = () => {
    this.setState({step: this.state.step - 1})
  }

  handleSubmit = (form) => {
    let coordinate: any = {};
    Object.keys(form).forEach((name, key) => {
      coordinate[name] = form[name].value
    });
    let dataFirstStep = this.state.dataFirstStep;
    const i18nFile: any = I18n.getFile();
    coordinate.type = i18nFile[dataFirstStep.type.value] != null ? i18nFile[dataFirstStep.type.value] : dataFirstStep.type.value;
    coordinate.informations = dataFirstStep.informations.value;
    coordinate.gearToInstall = i18nFile[dataFirstStep.gearToInstall.value] != null ? i18nFile[dataFirstStep.gearToInstall.value] : dataFirstStep.gearToInstall.value;
    coordinate.gearToReplace = i18nFile[dataFirstStep.gearToReplace.value] != null ? i18nFile[dataFirstStep.gearToReplace.value] : dataFirstStep.gearToReplace.value;
    const request = {
      noContrat: coordinate.noContract,
      eventType: "3",
      eventCode: 'MDFEQP',
      description: "Modification d'un équipement",
      confirm: '0',
      mail_object: WebEventUtil.getBodyOfEmail(coordinate),
      noClient: null,
      codeSite: null
    }
    this.webEventController.insertWebEvent(request).then(data => {
      this.setState({dataSend: true})
      this.next();
    }).catch(err => {
      console.log(err)
    })
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Installer ou remplacer un équipement"
                                                                      href="equipement"
                                                                      title="Transmettez-nous votre demande"/>}>
          <div className="container-xl mb-5">
            <GieCard width="100%" height="100%">
              {this.state.step < 2 && <HeaderForm step={this.state.step}
                                                  first="1 - Votre projet"
                                                  second="2 - Vos coordonnées"/>}
              {this.state.step === 0 && <MyEquipmentFormDetail next={this.getDataFirstStep}/>}
              {this.state.step === 1 && <MyCoordinateFormDetail confidentiality
                                                                offer
                                                                withButton={false}
                                                                previous={this.previous}
                                                                emit={this.handleSubmit}/>}
              {this.state.step === 2 && <MessageSuccess/>}
            </GieCard>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
